import { Menu } from 'antd'
import 'antd/lib/menu/style/index.css'

export default Menu
